/**
 * Mises en forme partagées.
 *
 * ⚠️ Il n'y a **pas** de fonction d'échappement ici, contrairement à la version
 * HTML qui en portait deux (toutes deux incomplètes). React échappe le texte
 * qu'il rend : c'est un des vrais gains du portage. La note de livraison, écrite
 * par le client, traverse les comptes — du client vers le marchand — et partait
 * brute dans plusieurs écrans de l'ancienne console.
 *
 * Le seul endroit où le risque revient est `dangerouslySetInnerHTML`. Il n'est
 * utilisé nulle part, et ne doit pas l'être.
 */

/** Séparateur d'espace fine tous les trois chiffres, comme partout ailleurs. */
export function fcfa(n: number | null | undefined): string {
  const v = Number(n) || 0
  return `${v.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')} FCFA`
}

export function reference(id: string): string {
  return `#${String(id ?? '').substring(0, 6).toUpperCase()}`
}

/** Durée écoulée, en clair : « 5 min », « 2h07 », « 3j ». */
export function depuis(iso: string): string {
  const minutes = Math.floor((Date.now() - new Date(iso).getTime()) / 60000)
  if (minutes < 1) return "à l'instant"
  if (minutes < 60) return `${minutes} min`
  const heures = Math.floor(minutes / 60)
  if (heures < 24) return `${heures}h${String(minutes % 60).padStart(2, '0')}`
  return `${Math.floor(heures / 24)}j`
}

export function dateComplete(d: string | null): string {
  if (!d) return '--'
  return new Date(d).toLocaleDateString('fr-FR', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

export function dateCourte(d: string | null): string {
  if (!d) return '--'
  return new Date(d).toLocaleDateString('fr-FR', { day: '2-digit', month: 'short', year: 'numeric' })
}
